<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Corporation Pinned Messages</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createPinnedMsg">Create Pinned Message</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="pinnedMsgs.columns" :data="pinnedMsgs.data">
                    <template slot="table-row" v-if="pinnedMsgs.data.length">
                        <tr v-for="(item, index) in pinnedMsgs.data" :key="index" :class="{'inactive': item.status === '0'}">
                          <td>{{item.corpAdminMessageId}}</td>
                            <td>{{item.corporationName}}</td>
                          <td>{{item.corpAdminMessage}}</td>
                          <td>{{item.msgSenderName}}</td>
                          <td>{{item.msgSentDateFmt}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewPinnedMsg(item)" v-tooltip.top-center="pinnedMsgs.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editPinnedMsg(item)" v-tooltip.top-center="pinnedMsgs.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const PinnedMsgsColumns = ['Id', 'Corporation', 'Pinned Message', 'By', 'Date', 'Status', 'Operations'];
    export default {
        name: 'PinnedMsgs',
        components: {
            LTable,
        },
        data() {
        return {
          pinnedMsgs: {
                tooltips: {
                    view: 'View Pinned Message',
                    edit: 'Edit Pinned Message',
                    delete: 'Inactivate Pinned Message',
                    activate:'Activate Pinned Message',
                },
                columns: [...PinnedMsgsColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchPinnedMessages () {
            this.$store.dispatch('FETCH_PINNEDMSGS')
                    .then((res) => {
                        console.log('returned Pinned Msgs', res)
                        this.pinnedMsgs.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewPinnedMsg(message){
            this.$router.push({ name: 'PinnedMsgDetail', params: { id: message.corpAdminMessageId}})
        },
        editPinnedMsg(message){
            this.$router.push({ name: 'EditPinnedMsg', params: { id: message.corpAdminMessageId}})
        },
        createPinnedMsg(){
            this.$router.push({ name: 'CreatePinnedMsg'})
        }
    },
    created() {
        this.fetchPinnedMessages();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PinnedMsgs/PinnedMsgs.vue